import { UserItemDtoPaginatedList } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListUsersDrawer } from 'views/foundation/user/drawers/ListUsersDrawer';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    trainingId: string;
    classroomId?: string | null;
    onlyMandatory: boolean;
    title?: string;
    subtitle?: string;
    onClose: () => void;
}

////////////////////////////////////////////////////////////////////////////

export const TrainingAudienceListUsersDrawer: React.FC<IProps> = ({ title, subtitle, trainingId, classroomId, onlyMandatory, onClose }) => {

    const api = useCoreApi();
    const { t } = useTranslation("lms");

    return <ListUsersDrawer
        title={title ??
            onlyMandatory
                ? t("Training.List.Overflow.MandatoryAudience")
                : t("Training.List.Overflow.Audience")
        }
        subtitle={subtitle}
        onGetData={
            ({ searchText, pageNumber, pageSize }, signal) =>
                new Promise<UserItemDtoPaginatedList>((resolve, reject) => {
                    api.v1.trainingManagement.getTrainingAudienceUsers({
                        searchText,
                        pageNumber,
                        pageSize,
                        trainingId: trainingId,
                        classroomId: classroomId || null,
                        onlyMandatory: onlyMandatory
                    }, { signal })
                        .then(result => resolve(result.data))
                        .catch(e => reject(e));
                })
        }
        onClose={onClose}
    />;

};

